import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, viewChild, ViewEncapsulation } from '@angular/core';
import { WindowComponent } from 'movisat-common-gui';
import { AppComponent } from 'src/app/app.component';
import { PluginsManager } from 'src/app/managers/plugins.manager';

@Component({
  selector: 'app-export-dialog',
  standalone: true,
  imports: [
    WindowComponent,
    CommonModule,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './export-dialog.component.html',
  styleUrl: './export-dialog.component.css',
})
export class ExportDialogComponent {
  public exportWindow = viewChild<WindowComponent>('WindowComponent');

  @Input() public fileName: string = 'export.xlsx';
  @Output() public actionChosen = new EventEmitter<string>();

  public static _this: ExportDialogComponent;

  public constructor(
    private pluginsManager: PluginsManager
  ) {}

  protected translate(text: string): string {
      return AppComponent.translate(text);
  }

  public isGoogleDriveEnabled(): boolean {
    if (this.pluginsManager.isPluginActive("Google Drive")) {
      return true;
    }
    return false;
  }

  public actionButtonClicked(event: { action: string }): void {
    this.actionChosen.emit(event.action);
  }
}
